import { alpha, Box, keyframes, SxProps, useTheme } from "@mui/material";
import { forwardRef, ReactNode } from "react";

type SuperButtonProps = {
  children: ReactNode;
  sx?: SxProps;
  onClick?: () => void;
  isShownPingIcon?: boolean;
};

const pingKeyframes = keyframes(
  `
  75%, 100% {
    transform: scale(2);
    opacity: 0;
  }
  `,
);

export const SuperButton = forwardRef(
  ({ children, sx = {}, onClick, isShownPingIcon }: SuperButtonProps, ref) => {
    const theme = useTheme();
    return (
      <Box
        ref={ref}
        component="label"
        sx={{
          position: "relative",
          background: alpha(theme.palette.primary.main, 0.06),
          paddingY: "0.5rem 0.5rem",
          cursor: "pointer",
          borderRadius: "1rem",
          width: "279px",
          padding: "20px",
          "&:hover": {
            backgroundColor: alpha(theme.palette.primary.main, 0.2),
            boxShadow: `0px 8px 24px 0px ${alpha(theme.palette.primary.main, 0.16)}`,
          },
          ...sx,
        }}
        onClick={() => onClick?.()}
      >
        {isShownPingIcon && (
          <Box
            sx={{
              display: "flex",
              position: "absolute",
              height: "0.75rem",
              width: "0.75rem",
              top: 0,
              right: 0,
              marginTop: "-0.25rem",
              marginRight: "-0.25rem",
            }}
          >
            <Box
              sx={{
                backgroundColor: theme.palette.primary.dark,
                animation: `${pingKeyframes} 1s cubic-bezier(0, 0, 0.2, 1) infinite`,
                position: "absolute",
                display: "inline-flex",
                height: "100%",
                width: "100%",
                borderRadius: "50%",
                opacity: 0.75,
              }}
            />
            <Box
              sx={{
                position: "relative",
                display: "inline-flex",
                borderRadius: "50%",
                height: "0.75rem",
                width: "0.75rem",
                backgroundColor: theme.palette.primary.dark,
              }}
            />
          </Box>
        )}
        {children}
      </Box>
    );
  },
);
